import "./SiemensManageMyMachine.module.css";
import Header from "@/reusable_sections/Header";
import ManageMyMachine from "./sections/ManageMyMachine";
import Management from "./sections/Management";
import Specifications from "./sections/Specifications";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function SiemensManageMyMachinePage() {
  return <div>
      <Header />
      <ManageMyMachine />
      <Management />
      <Specifications />
      <Cta />
      <Footer />
    </div>;
}